'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;
exports.checkChanged = checkChanged;
exports.submit = submit;
exports.removeFromPreselection = removeFromPreselection;
exports.productNumberChange = productNumberChange;
exports.onPolicyChange = onPolicyChange;
exports.addToPreselection = addToPreselection;
exports.buyImmediately = buyImmediately;
exports.clearBuyImmediatelyInfo = clearBuyImmediatelyInfo;
exports.productAddedInfoAllClear = productAddedInfoAllClear;
exports.clearSubmitError = clearSubmitError;
exports.openDetailModal = openDetailModal;
exports.closeDetailModal = closeDetailModal;
exports.getDetail = getDetail;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by Administrator on 2016/7/2.
 */
var LOAD = 'goeasy-crafts/preselection/LOAD';
var LOAD_SUCCESS = 'goeasy-crafts/preselection/LOAD_SUCCESS';
var LOAD_FAIL = 'goeasy-crafts/preselection/LOAD_FAIL';

var CHECKCHANGED = 'goeasy-crafts/preselection/CHECKCHANGED';
var CHECKCHANGED_SUCCESS = 'goeasy-crafts/preselection/CHECKCHANGED_SUCCESS';
var CHECKCHANGED_FAIL = 'goeasy-crafts/preselection/CHECKCHANGED_FAIL';

var SUBMIT = 'goeasy-crafts/preselection/SUBMIT';
var SUBMIT_SUCCESS = 'goeasy-crafts/preselection/SUBMIT_SUCCESS';
var SUBMIT_FAIL = 'goeasy-crafts/preselection/SUBMIT_FAIL';

var REMOVE = 'goeasy-crafts/preselection/REMOVE';
var REMOVE_SUCCESS = 'goeasy-crafts/preselection/REMOVE_SUCCESS';
var REMOVE_FAIL = 'goeasy-crafts/preselection/REMOVE_FAIL';

// CHANGESTATUS, CHANGESTATUS_SUCCESS, CHANGESTATUS_FAIL
var POLICYCHANGE = 'goeasy-crafts/preselection/POLICYCHANGE';
var POLICYCHANGE_SUCCESS = 'goeasy-crafts/preselection/POLICYCHANGE_SUCCESS';
var POLICYCHANGE_FAIL = 'goeasy-crafts/preselection/POLICYCHANGE_FAIL';

var NUMBERCHANGE = 'goeasy-crafts/preselection/NUMBERCHANGE';
var NUMBERCHANGE_SUCCESS = 'goeasy-crafts/preselection/NUMBERCHANGE_SUCCESS';
var NUMBERCHANGE_FAIL = 'goeasy-crafts/preselection/NUMBERCHANGE_FAIL';

var ADD = 'goeasy-crafts/preselection/ADD';
var ADD_SUCCESS = 'goeasy-crafts/preselection/ADD_SUCCESS';
var ADD_FAIL = 'goeasy-crafts/preselection/ADD_FAIL';

var BUY = 'goeasy-crafts/preselection/BUY';
var BUY_SUCCESS = 'goeasy-crafts/preselection/BUY_SUCCESS';
var BUY_FAIL = 'goeasy-crafts/preselection/BUY_FAIL';

var CLEARADDINFO = 'goeasy-crafts/preselection/CLEARADDINFO';

var CLEARSUBMITERROR = 'goeasy-crafts/preselection/CLEARSUBMITERROR';

var CLEARBUYATONCEINFO = 'goeasy-crafts/preselection/CLEARBUYATONCEINFO';

var OPENDETAILMODAL = 'goeasy-crafts/preselection/OPENDETAILMODAL';

var CLOSEDETAILMODAL = 'goeasy-crafts/preselection/CLOSEDETAILMODAL';

var GETDETAIL = 'goeasy-crafts/preselection/GETDETAIL';
var GETDETAIL_SUCCESS = 'goeasy-crafts/preselection/GETDETAIL_SUCCESS';
var GETDETAIL_FAIL = 'goeasy-crafts/preselection/GETDETAIL_FAIL';

var initialState = {
  loaded: false,
  detailData: {},
  submitted: false
};

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: (0, _extends3.default)({}, state.data, action.result)
      });

    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case CHECKCHANGED:
      return (0, _extends3.default)({}, state, {
        checkChanging: true
      });
    case CHECKCHANGED_SUCCESS:
      return (0, _extends3.default)({}, state, {
        checkChanging: false,
        checkChanged: true,
        data: action.result
      });
    case CHECKCHANGED_FAIL:
      return (0, _extends3.default)({}, state, {
        checkChanging: false,
        checkChanged: false,
        checkChangeError: action.error
      });
    case SUBMIT:
      return (0, _extends3.default)({}, state, {
        submitting: true,
        submitted: false
      });
    case SUBMIT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        submitting: false,
        submitted: true,
        submitData: action.result
      });
    case SUBMIT_FAIL:
      return (0, _extends3.default)({}, state, {
        submitting: false,
        submitted: false,
        error: action.error
      });
    case CLEARSUBMITERROR:
      return (0, _extends3.default)({}, state, {
        submitData: null
      });
    case CLEARBUYATONCEINFO:
      return (0, _extends3.default)({}, state, {
        buyData: null
      });
    case REMOVE:
      return (0, _extends3.default)({}, state, {
        removing: true
      });
    case REMOVE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        removing: false,
        removed: true,
        data: action.result
      });
    case REMOVE_FAIL:
      return (0, _extends3.default)({}, state, {
        removing: false,
        removed: false,
        error: action.error
      });
    case NUMBERCHANGE:
      return (0, _extends3.default)({}, state, {
        numberChanging: true
      });
    case NUMBERCHANGE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        numberChanging: false,
        numberChanged: true,
        data: action.result
      });
    case NUMBERCHANGE_FAIL:
      return (0, _extends3.default)({}, state, {
        numberChanging: false,
        numberChanged: false,
        error: action.error
      });

    case GETDETAIL:
      return (0, _extends3.default)({}, state, {
        detailGetting: true
      });
    case GETDETAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        detailGetting: false,
        detailGotten: true,
        detailData: action.result
      });
    case GETDETAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        detailGetting: false,
        detailGotten: false,
        detailData: {},
        error: action.error
      });
    case OPENDETAILMODAL:
      return (0, _extends3.default)({}, state, {
        detailModalOpened: true,
        modalProductId: action.productId
      });
    case CLOSEDETAILMODAL:
      return (0, _extends3.default)({}, state, {
        detailModalOpened: false,
        modalProductId: '',
        detailData: {}
      });
    case POLICYCHANGE:
      return (0, _extends3.default)({}, state, {
        policyChanging: true
      });
    case POLICYCHANGE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        policyChanging: false,
        policyChanged: true,
        data: action.result
      });
    case POLICYCHANGE_FAIL:
      return (0, _extends3.default)({}, state, {
        policyChanging: false,
        policyChanged: false,
        error: action.error
      });
    case ADD:
      return (0, _extends3.default)({}, state, {
        adding: true
      });
    case ADD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        adding: false,
        added: true,
        addData: action.result
      });
    case ADD_FAIL:
      return (0, _extends3.default)({}, state, {
        adding: false,
        added: false,
        error: action.error
      });
    case BUY:
      return (0, _extends3.default)({}, state, {
        buying: true
      });
    case BUY_SUCCESS:
      return (0, _extends3.default)({}, state, {
        buying: false,
        buyed: true,
        buyData: action.result
      });
    case BUY_FAIL:
      return (0, _extends3.default)({}, state, {
        buying: false,
        buyed: false,
        buyData: null,
        error: action.error
      });
    case CLEARADDINFO:
      return (0, _extends3.default)({}, state, {
        addData: null
      });
    default:
      return state;
  }
}

function load(page, pageChange) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post('/preselection', {
        data: {
          type: 'getData',
          page: page,
          pageChange: pageChange
        }
      });
    }
  };
}

function checkChanged(info, orderNumber, page) {
  return {
    types: [CHECKCHANGED, CHECKCHANGED_SUCCESS, CHECKCHANGED_FAIL],
    promise: function promise(client) {
      return client.post('/preselection', {
        data: {
          type: 'checkChange',
          info: info,
          orderNumber: orderNumber,
          page: page
        }
      });
    }
  };
}

function submit(products, orderNumber) {
  return {
    types: [SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAIL],
    promise: function promise(client) {
      return client.post('/preselection', {
        data: {
          type: 'submit',
          products: products,
          orderNumber: orderNumber
        }
      });
    }
  };
}

function removeFromPreselection(info, orderNumber) {
  return {
    types: [REMOVE, REMOVE_SUCCESS, REMOVE_FAIL],
    promise: function promise(client) {
      return client.post('/preselection', {
        data: {
          type: 'removeFromPreselection',
          info: info,
          orderNumber: orderNumber
        }
      });
    }
  };
}

function productNumberChange(info, orderNumber) {
  return {
    types: [NUMBERCHANGE, NUMBERCHANGE_SUCCESS, NUMBERCHANGE_FAIL],
    promise: function promise(client) {
      return client.post('/preselection', {
        data: {
          type: 'numberChange',
          info: info,
          orderNumber: orderNumber
        }
      });
    }
  };
}

function onPolicyChange(info, orderNumber, currentPage) {
  return {
    types: [POLICYCHANGE, POLICYCHANGE_SUCCESS, POLICYCHANGE_FAIL],
    promise: function promise(client) {
      return client.post('/preselection', {
        data: {
          type: 'policyChange',
          info: info,
          orderNumber: orderNumber,
          currentPage: currentPage
        }
      });
    }
  };
}
function addToPreselection(addItem) {
  return {
    types: [ADD, ADD_SUCCESS, ADD_FAIL],
    promise: function promise(client) {
      return client.post('/preselection', {
        data: {
          type: 'addToPreselection',
          addItem: addItem
        }
      });
    }
  };
}

function buyImmediately(buyItem) {
  // console.log(buyItem);
  return {
    types: [BUY, BUY_SUCCESS, BUY_FAIL],
    promise: function promise(client) {
      return client.post('/preselection', {
        data: {
          type: 'buyImmediately',
          buyItem: buyItem
        }
      });
    }
  };
}

function clearBuyImmediatelyInfo() {
  return {
    type: CLEARBUYATONCEINFO
  };
}

function productAddedInfoAllClear() {
  return {
    type: CLEARADDINFO
  };
}

function clearSubmitError() {
  return {
    type: CLEARSUBMITERROR
  };
}

function openDetailModal(productId) {
  return {
    type: OPENDETAILMODAL,
    productId: productId
  };
}

function closeDetailModal() {
  return {
    type: CLOSEDETAILMODAL
  };
}

function getDetail(productId, orderNumber) {
  return {
    types: [GETDETAIL, GETDETAIL_SUCCESS, GETDETAIL_FAIL],
    promise: function promise(client) {
      return client.post('/preselection', {
        data: {
          type: 'getDetail',
          productId: productId,
          orderNumber: orderNumber
        }
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/preselection.js
 ** module id = 200
 ** module chunks = 0
 **/